import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  // Only redirect after MSAL has finished and user is authenticated
  React.useEffect(() => {
    if (inProgress === "none" && isAuthenticated) {
      const path = sessionStorage.getItem("postLoginRedirectPath") || "/";
      navigate(path, { replace: true });
    }
  }, [inProgress, isAuthenticated, navigate]);

  return (
    <div>
      <h2>Completing login...</h2>
      <p>If you are not redirected, please check your authentication status.</p>
    </div>
  );
}
